import type { UserStatement } from '@/types/userStatement'

/**
 * Most recent issued statement by tax-year period.
 * Free donors only receive that one statement from the API. Paid donors
 * receive the history, and the shortcut still points at the latest year.
 */
export function selectLatestStatement(
  statements: UserStatement[]
): UserStatement | null {
  if (statements.length === 0) return null
  return [...statements].sort((a, b) => b.period.localeCompare(a.period))[0]
}
